import axios from 'axios/index';
import type PublicStore from '../stores/PublicStore';

class TranslateRepository {
  URL: string;

  TIMEOUT: number;

  constructor() {
    this.URL = `${process.env.REACT_APP_API_SERVICE_HOST}`;
    // 서버가 응답을 다 쓸 때까지의 상한(ErpService 의 WriteTimeout 20s) 보다
    // 넉넉해야 한다. 그 20s 안에서 서버는 코얼레싱 창(3s) + 모델 호출(10s) +
    // 캐시 왕복과 인증 몫을 나눠 쓴다. 여기서 먼저 끊으면 서버가 값을 다 치르고
    // 저장까지 마친 번역을 우리 손으로 버리게 된다.
    this.TIMEOUT = 25000;
  }

  /**
   * ErpService 의 permission 미들웨어는 body 의 token/window 를 검사한다.
   * w_xusers 는 로그인 사용자라면 항상 접근 가능한 전역 윈도우다.
   */
  private async params(publicStore: PublicStore, body: any): Promise<any> {
    return {
      ...await publicStore.makeParamsWithWindowName('w_xusers', {}),
      ...body,
    };
  }

  async all(publicStore: PublicStore, lang: string): Promise<Record<string, string>> {
    const { data } = await axios.post(
      `${this.URL}/i18n/all`,
      await this.params(publicStore, { lang }),
      { timeout: this.TIMEOUT },
    );

    return data?.items || {};
  }

  async translate(publicStore: PublicStore, lang: string, texts: Array<string>): Promise<Record<string, string>> {
    const { data } = await axios.post(
      `${this.URL}/i18n/translate`,
      await this.params(publicStore, { lang, texts }),
      { timeout: this.TIMEOUT },
    );

    return data?.items || {};
  }
}

export default new TranslateRepository();
